export const one_dirham = 22.44; // UAE Currency
export const one_dirham_multipler = 0.0445632798573975; // UAE Currency

export const weightloss_uae = {
  _id: '1',
  itemType: 'PDP_VARIANT_OPTIONS',
  itemId: 1,
  position: 5,
  itemName: 'PDP size and pack',
  generalItemId: null,
  platform: ['app', 'web', 'ios'],
  pdpVariantData: [
    {
      sizeChart: '',
      sizeChartImagesArr: [],
      masterId: 11,
      variant_type: 'Plan',
      dispaly_style: '5',
      sequence: 1,
      data: [
        {
          selected: '1',
          availability: '0',
          product_id: 3186,
          variant_features: [
            {
              feature: 'Improved lactation  ',
            },
            {
              feature: 'Up to 8-10 Kgs weight reduction ',
            },
            {
              feature: 'Inch Loss - up to 8- 10 inches     ',
            },
            {
              feature: 'Increased muscle strength & bone density   ',
            },
            {
              feature: 'Organ healing with traditional techniques ',
            },
          ],
          is_best_value: '1',
          best_value_text: '',
          best_value_text_color: '#000000',
          title: '3 Months Advance Plan',
          image: '',
          masterId: 11,
          icon: null,
          web_url: '/clinic/post-pregnancy-weight-loss-plan-international-3186',
          name: 'Post Pregnancy Weight Loss Plan (International)',
          price: 447,
          strikeprice: 19999,
          delivery: 0,
          gullackpoints: 0,
          productMainImage: '',
          bookNowCta: 'Book Now',
          bookNowCtaDeeplink: 81,
          bookNowCtaDeeplinkValue: 3186,
          perMonthPrice: '149',
          perMonthPriceText: '/mo',
          priceText: 'You Pay',
          isOutOfStock: false,
        },
      ],
      heading: 'Select Package',
      enableSelection: true,
    },
  ],
};
